import PanelLayout from "../../layout/PanelLayout";
import AssetCard from "../../components/pages/AssetCard";

const SavedAsset = () => {
  return (
    <PanelLayout>
      <section class="ct_py_80  ">
        <div class="container">
          <div class="row">
            <div class="col-md-12">
              <div class="d-flex align-items-center justify-content-between mb-2">
                <div>
                  <h5 class="ct_fs_32 ct_fw_600 mb-0">Saved Assets</h5>
                </div>
              </div>
            </div>
          </div>
          <div class="row ct_mt_30 gx-md-5">
            {[1, 2].map((item, index) => (
              <AssetCard
                data={{
                  promote: 1,
                  AssetImages: [{ image_url: "/assets/img/assets_1.png" }],
                  id: index + 1,
                  latitude: "",
                  longitude: "",
                  lock: index % 2 == 0 ? 1 : 0,
                  UIC: "6568520",
                  AssetName: "iPhone 15",
                  isStolen: index % 2 == 0 ? true : false,
                  AssetDetails:
                    "This property is not available for sale. Kindly...",
                }}
              />
            ))}
          </div>
        </div>
      </section>
    </PanelLayout>
  );
};

export default SavedAsset;
